<template>
 <a-locale-provider :locale="zh_CN">
  <div id="app">
    <router-view/>
  </div>
  </a-locale-provider>
</template>

<script>
  import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
  import moment from 'moment';
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

export default {
  name: 'App',
  data() {
    return {
      zh_CN
    };
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}



td.column-money {
  text-align: right !important;
}
.ant-advanced-search-form {
  margin: 0px 0px;
  padding: 5px 12px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 1px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}
.editable-btn {
  margin-bottom: 8px;
  margin-top: 8px;
  background-color: white;
}
.editable-add-btn {
  margin-bottom: 8px;
}

#components-form-demo-advanced-search .search-result-list {
  margin: 0px 10px;
  border: 0px solid #e9e9e9;
  border-radius: 1px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue